import { ContentFlightStatus } from './contentflightstatus.model';
import { ContentCheckIn } from './contentcheckin.model';
import { ContentMyTrip } from './contentmytrip.model';
import { ContentBook } from './contentbook.model';

export class ContentPrimaryNavigation {
  id: any;
  label: any;
  searchUrl: any;
  details: any;
  redirectMobile: any;
  redirectMobileUrl: any;

  constructor(id: any, contentjson?: any) {
    if (contentjson) {
      this.id = contentjson['id'];
      this.label = contentjson['label'];
      this.searchUrl = contentjson['searchUrl'];
      this.redirectMobile = contentjson['redirectMobile'];
      this.redirectMobileUrl = contentjson['redirectMobileUrl'];
      this.details = this.fillDetails(contentjson);
    }
  }

  private fillDetails(contentjson?: any): any {
    let details: any;
    if (contentjson) {
      if (contentjson['id']) {
        switch (contentjson['id']) {
          case 'book': {
            details = new ContentBook(contentjson);
            break;
          }
          case 'check_in': {
            details = new ContentCheckIn(contentjson);
            break;
          }
          case 'my_trips': {
            details = new ContentMyTrip(contentjson);
            break;
          }
          case 'flightstatus': {
            details = new ContentFlightStatus(contentjson);
            break;
          }
          default: {
            details = null;
            break;
          }
        }
      }
    }
    return details;
  }
}
